import React from "react";
import "./index.scss";

const SplitPane = ({ left, right }) => {
  return (
    <div className="splitpane">
      <div className="splitpane-left">{left}</div>
      <div className="splitpane-right">{right}</div>
    </div>
  );
};

export default SplitPane;
